import React, { useEffect } from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import { useNavigate, Link } from "react-router-dom";
import GameCard from "../components/GameCard";
import { createGame as createPacman } from "../games/pacman";
import { createGame as createSnake } from "../games/snake";

const games = [
  {
    id: "pacman",
    name: "PacZel",
    tagline: "Classic maze action — eat pellets, dodge ghosts, grab power-ups.",
    controls: "Arrow keys / WASD to move • R to restart",
    create: createPacman,
  },
  {
    id: "snake",
    name: "ZelSnake",
    tagline: "Grow as long as you can without biting yourself.",
    controls: "Arrow keys / WASD to steer • R to restart",
    create: createSnake,
  },
];

const Games = () => {
  useDocTitle("ZelT | Game Area");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("zelt_token");
    if (!token) {
      navigate("/membership");
    }
  }, [navigate]);

  return (
    <div>
      <NavBar />
      <div id="games" className="mt-8 w-full bg-white py-12 lg:py-24">
        <div className="mx-4 lg:mx-20">
          <div className="text-center mb-10" data-aos="zoom-in">
            <h1 className="mb-3 text-3xl md:text-4xl font-bold text-blue-900">
              🎮 Member Game Area
            </h1>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">
              Exclusive free games for ZelTechnology members. Beat your own
              high score — it's saved on your account device.
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto" data-aos="fade-up">
            <GameCard game={games[0]} />
            <GameCard game={games[1]} />
          </div>
          <p className="text-center text-gray-400 mt-8">
            Want more games? Let us know on the{" "}
            <Link to="/contact" className="text-blue-900 font-bold hover:underline">
              contact page
            </Link>
            !
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Games;
